// extracted by mini-css-extract-plugin
module.exports = {"current":"current___3OJAF","sizes":"sizes___7LBz1","success":"success___2wQI_","error":"error___177J6"};